<template>
    <div>
        <div class="d-flex align-items-end">
            <b-form-group label-size="sm" class="mb-0 mt-0" label="Тип оплаты:">
                <b-form-select v-model="order.typePayment" :disabled="readonly" :options="tp"></b-form-select>
            </b-form-group>
            <b-button class="ml-1" v-if="isComboPayment" :variant="errorValidator !== null ? 'danger' : null" v-b-modal.modal-add-payment><icon class="" :name="!readonly ? 'edit' : 'eye'"></icon></b-button>
        </div>

        <b-modal id="modal-add-payment" ref="modal-add-payment" @show="showModal" @hide="hideModal" centered :ok-only="true" @ok="savePayment()" ok-title="Сохранить" title="Типы оплаты:" :hide-footer="readonly">
            <b-alert v-if="errorValidator !== null" show variant="danger">{{errorValidator.error}}</b-alert>
            <div class="mb-3 text-center">Сумма заказа: <b>{{orderSum}}</b></div>
            <b-row class="mb-1 paymentRow" v-for="(paymentItem, index) in selectedPayments" :key="paymentItem.type.keyword + index">
                <b-col md="9">
                    <b-row>
                        <b-col md="8">
                            <b-form-group label-size="sm" class="mb-0 mt-0" label="Тип оплаты:">
                                <b-form-select v-model="paymentItem.type" :options="typesPaymentFiltered" :disabled="paymentItem.disabled || readonly"> <!--v-model="order.typePayment" :disabled="readonly"  -->
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group label-size="sm" class="mb-0 mt-0" label="Сумма:">
                                <b-form-input v-model.number="paymentItem.sum" type="number" placeholder="Введите сумму" @keyup="paymentSumChanged($event)" :disabled="paymentItem.disabled  || readonly"> <!--v-model="order.typePayment" :disabled="readonly"  -->
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="3" v-if="!paymentItem.disabled">
                    <b-row>
                        <b-col md="4" class="pl-0">
                            <b-button size="sm" v-if="!readonly" @click="setRemainingSum(index)" v-b-tooltip.hover title="Назначить остаток суммы" variant="success"><icon name="angle-double-left"></icon></b-button>
                        </b-col>
                        <b-col md="4" class="pl-0">
                            <b-button size="sm" v-if="!readonly" @click="deletePayment(index)" variant="danger"><icon name="times"></icon></b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-button class="w-100 mt-3" v-if="!readonly" size="md" @click="addPayment()" variant="success">Добавить тип оплаты</b-button>
        </b-modal>
    </div>
</template>

<script>
import {TYPE_PAYMENT} from '@/constants/keywords'
export default {
  name: 'ModalAddPayment',
  props: {
    typesPayment: {
      type: Array,
      required: true
    },
    orderSum: {
      type: Number,
      required: true
    },
    readonly: {
      type: Boolean,
      required: true
    },
    order: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      TYPE_PAYMENT,
      selectedPayments: [],
      selectedPaymentsWas: [],
      forceHide: false,
      typePaymentEmpty: null
    }
  },
  methods: {
    paymentSumChanged (el) {
      let inputNumber = parseInt(el.target.value.replace(/\D+/g, ''))
      if (inputNumber < 0) {
        el.target.value = Math.abs(inputNumber)
      }
      el.target.value = inputNumber
    },
    addPayment () {
      this.selectedPayments.push(Object.assign({}, this.typePaymentEmpty))
    },
    savePayment () {
      this.forceHide = true
      let newPaymentInfo = {}
      this.selectedPayments.forEach(payment => {
        let paymentKeyword = payment.type.keyword
        let sumPayment = payment.sum ? payment.sum : 0
        if (newPaymentInfo[paymentKeyword] !== undefined) {
          newPaymentInfo[paymentKeyword] += sumPayment
        } else {
          newPaymentInfo[paymentKeyword] = sumPayment
        }
      })
      this.$emit('updatePaymentOnlyInfo', newPaymentInfo)
      this.$emit('updateTypePaymentCombined')
    },
    deletePayment (index) {
      this.selectedPayments.splice(index, 1)
    },
    setRemainingSum (index) {
      let item = this.selectedPayments[index]
      item.sum = Math.max(0, parseInt(this.orderSum) - parseInt(this.sumPayments) + parseInt(item.sum))
    },
    showModal () {
      this.forceHide = false
      this.updatePayments()
    },
    updatePayments () {
      this.selectedPayments = []
      if (this.order.typePayment.keyword !== TYPE_PAYMENT.COMBO) {
        let paymentObj = this.typesPayment.find(el => el.value.keyword === this.order.typePayment.keyword).value
        this.selectedPayments.push({
          type: paymentObj,
          sum: this.orderSum
        })
      } else {
        if (this.order.paymentOnlyInfo) {
          let payments = this.order.paymentOnlyInfo
          for (let keywordPayment in payments) {
            let snakeKeyword = this.$lodash.snakeCase(keywordPayment)
            if (keywordPayment === '__typename' || parseFloat(payments[keywordPayment]) === 0.0) {
              continue
            }
            let paymentObj = this.typesPayment.find(el => el.value.keyword === snakeKeyword).value
            this.selectedPayments.push({
              type: paymentObj,
              sum: payments[keywordPayment],
              disabled: keywordPayment === 'cardOnline' || keywordPayment === 'card_online'
            })
          }
        }
      }
      this.selectedPaymentsWas = [...this.selectedPayments]
    },
    wasEditedPayments () {
      return JSON.stringify(this.selectedPayments) !== JSON.stringify(this.selectedPaymentsWas)
    },
    hideModal (event) {
      if ((this.errorValidator === null && this.wasEditedPayments()) && !this.forceHide && !this.readonly) {
        event.preventDefault()
        let result = confirm('Типы оплаты были изменены, отменить изменения?')
        if (result) {
          this.forceHide = true
          this.$refs['modal-add-payment'].hide()
        }
      }
    },
    emitNotCorrectSum (error) {
      if (this.isComboPayment) {
        this.$emit('disable-not-correct-sum', error !== null)
      } else {
        this.$emit('disable-not-correct-sum', false)
      }
    }
  },
  computed: {
    tp () {
      if (this.order && this.order.payment) {
        return this.typesPayment.map((paymentType) => ({
          ...paymentType,
          disabled: false
        }))
      } else {
        return this.typesPayment
      }
    },
    sumPayments () {
      return this.selectedPayments.reduce((sum, curr) => {
        return sum + parseInt(curr.sum ? curr.sum : 0)
      }, 0)
    },
    errorValidator () {
      if (this.sumPayments !== this.orderSum) {
        let diff = Math.abs(this.orderSum - this.sumPayments)
        return {error: `Сумма заказа не совпадает с суммой оплат на ${diff} руб.`}
      }
      return null
    },
    typesPaymentFiltered () {
      return this.tp.filter(el => el.value.keyword !== TYPE_PAYMENT.COMBO)
    },
    isComboPayment () {
      return this.order.typePayment.keyword === TYPE_PAYMENT.COMBO
    }
  },
  watch: {
    'order.typePayment' (val, oldVal) {
      if (oldVal.keyword !== val.keyword && oldVal.keyword === 'combo') {
        this.order.paymentOnlyInfo = null
      }
      this.emitNotCorrectSum(this.errorValidator)
    },
    order () {
      this.updatePayments()
    },
    errorValidator (val) {
      this.emitNotCorrectSum(val)
    }
  },
  created () {
    if (this.payments) {
      this.selectedPayments = Object.assign({}, this.payments)
    } else {
      this.selectedPayments = []
    }
    let typePayment = this.typesPayment.find(el => el.value.keyword === TYPE_PAYMENT.CASH)
    this.typePaymentEmpty = {
      type: typePayment.value,
      sum: 0
    }
    this.updatePayments()
  }
}
</script>

<style scoped>
    .paymentRow {
        align-items: flex-end;
    }
</style>



// WEBPACK FOOTER //
// src/components/ModalAddPayment.vue